import React from 'react';
import { useTranslation } from 'react-i18next';

import { logout } from '../../globals-service';

import TFAAppEnable from 'components/TFAAppEnable';


import './TeamTFARequired.styles.css';

const TeamTFARequired = ({ email, authToken, onSuccess }) => {
    const { t } = useTranslation('settings', 'common');

    const handleCancelClick = () => {
        logout(true);
    }

    return (
        <div className="team-tfa-required">
            <h3>{ t('tfa.teamRequired') }</h3>

            <div className="team-tfa-required-main">
                <TFAAppEnable email={email} authToken={authToken} onEnd={handleCancelClick} onSuccess={onSuccess} />
            </div>
        </div>
    );
}

export default TeamTFARequired;
